const options = {
	context:{
		primary_business_unit: 'fng',
		secondary_business_unit: 'fox sports',
		app_name: 'foxsports.com',
		app_platform: 'web',
		app_version: null
	}
};

class SegmentAnalytics {
	constructor() {
		this.isLoaded = false;
		this.init();
	}

	init() {
		let metaEl = document.querySelector('[fs-prop="analytics"]');

		if (!metaEl) {
			throw new Error('ANALYTICS !! - something went wrong getting page\'s meta');
		}

		let apiKey = metaEl.getAttribute('segment-api-key');
		let pageName = metaEl.getAttribute('page-name');

		// use this value as referrer for dynamically loaded pages
		this.defaultSpaReferrer = window.location.href;

		if (!apiKey) {
			throw new Error('ANALYTICS !! - Segment Analytics Api Key is not provided');
		}

		this.initSegmentAnalytics(apiKey, pageName);
	}

	initSegmentAnalytics(apiKey, pageName) {
		let self = this;

		!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement("script");e.type="text/javascript";e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+"cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION="4.0.0";
			analytics.load(apiKey);
			analytics.page(pageName, null, null, options, () => self.isLoaded = true);
		}}();
	}

	page(data) {
		if (!this.isLoaded) {
			throw new Error('ANALYTICS !! - Segment Analytics is not initialized');
		}

		analytics.page({
			name: data.page_name,
			path: data['dom.pathname'],
			url: data['dom.url'],
			title: data.story_title,
			referrer: this.defaultSpaReferrer
		}, options);
	}
}

export default new SegmentAnalytics();



// WEBPACK FOOTER //
// ./assets/components/analytics/SegmentAnalytics.js